import trainingGroups from '@/store/modules/training-groups/training-groups'
import trainingGroupsCreate from '@/store/modules/training-groups/training-groups-create'
import trainingGroupsEdit from '@/store/modules/training-groups/training-groups-edit'
import trainingGroupsDelete from '@/store/modules/training-groups/training-groups-delete'
import trainingGroupsList from '@/store/modules/training-groups/training-groups-list'
import trainingGroupsTrainer from '@/store/modules/training-groups/training-groups-trainer'

export default {
  trainingGroups,
  trainingGroupsCreate,
  trainingGroupsEdit,
  trainingGroupsDelete,
  trainingGroupsList,
  trainingGroupsTrainer,
}
